// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.KFR7NC2M.js
var id = 0;
function autoIncrement() {
  return ++id;
}

export {
  autoIncrement
};
